import {extractCSPNonce} from '../../shared/extractCspNonce';

const injectScript = (
  SCRIPT: string,
  callback = () => {},
  onError = () => {},
) => {
  const script = document.createElement('script');
  script.src = SCRIPT;
  script.onload = callback;
  script.onerror = onError;

  // Nonce needs to be here for the script to be able to run
  const nonce = extractCSPNonce('script');
  if (nonce) {
    script.setAttribute('nonce', nonce);
  }
  document.body && document.body.appendChild(script);
};

export default injectScript;
